$(function(){
	/* =====================================================
	Tooltip Box
	====================================================== */

	/*
	<a class="tooltip-box__trigger" href="#" data-tooltip-box-target="box-id">Show Tooltip Box</a>
	...
	<div id="box-id" class="tooltip-box">
		<span class="tooltip-box__close"></span>
		{content}
	</div>
	*/

	$.fn.aceTooltip = function () {
		$(this).each(function(i, triggerEl) {
			const trigger = $(triggerEl);
			const target = $("#" + trigger.data("tooltip-box-target"));
			const closeBtn = target.find(".tooltip-box__close");
			const allTooltips = $('.tooltip-box');

			// SHOW

			trigger.on("click", function(e) {
				e.preventDefault();
				allTooltips.removeClass("tooltip-box--active");
				target.addClass("tooltip-box--active");
			});

			// HIDE

			closeBtn.on("click", function() {
				target.removeClass("tooltip-box--active");
			});

			$(document).on('click', function (event) {
				const clickedEl = $(event.target);
				const outsideClick = !clickedEl.is('.tooltip-box, .tooltip-box__trigger, .tooltip-box__trigger *') && !clickedEl.parent('.tooltip-box').length > 0;

				if (outsideClick) {
					allTooltips.removeClass('tooltip-box--active');
				}
			});
		})
    };

	// Bind

	$(".tooltip-box__trigger").aceTooltip();
});
